import {ANALYZE_FOR_ENTRY_COMPONENTS, NgModule } from "@angular/core";
import { Routes, RouterModule, ROUTES } from "@angular/router";
import { SolicitudesComponent } from "./componentes/solicitudes/solicitudes.component";
import { ArchivosComponent } from "./componentes/archivos/archivos.component";
import { ContratoComponent } from "./componentes/contrato/contrato.component";
import { OpcionesTablaComponent } from "../shared/components/opciones-tabla/opciones-tabla.component";

const routes: Routes = [
  { path: "solicitud_unica", component: SolicitudesComponent },
  { path: "solicitud_unica/:id", component: SolicitudesComponent },
  { path: "solicitud_unica/edit/:id", component: SolicitudesComponent },
  { path: "selector_documentos", component: ArchivosComponent },
  { path: "contrato", component: ContratoComponent },
  { path: "contrato/:id", component: ContratoComponent },
  { path: "opciones", component: OpcionesTablaComponent },
];
@NgModule({
  imports: [{
    ngModule: RouterModule,
    providers: [
      {
        provide: ANALYZE_FOR_ENTRY_COMPONENTS,
        multi: true,
        useValue: routes
      },
      {
        provide: ROUTES,
        multi: true,
        useValue: routes
      }
    ]
  }],
  exports: [RouterModule],
})
export class SolicitudesRoutingModule {}
